// extracted by mini-css-extract-plugin
export var addToCartButton = "_uj-b";
export var arrowButtonContainer = "_uj-9";
export var arrowButtonIcon = "_uj-a";
export var carouselArrowButton = "_uj-6";
export var carouselElementContainer = "_uj-1";
export var left = "_uj-7";
export var productDisplayCarouselContainer = "_uj-0";
export var productTileContainer = "_uj-2";
export var productTileImage = "_uj-4";
export var productTileImageContainer = "_uj-3";
export var productTileTitle = "_uj-5";
export var right = "_uj-8";
export var sliderOverflow = "_uj-c";